import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  useTheme,
  TextField,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'umi';
import ModalML from '@/components/ModalML';
import CouponModal from '../operate_modal/coupon_modal/index';
import NumberFormatML from '@/components/NumberFormatML';
import Checkbox from '@material-ui/core/Checkbox';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import CampaignEquityStyled from './CampaignEquityStyled';

//数字问题
const NumberFormatCustom = React.forwardRef((props, ref) => (
  <NumberFormatML {...props} allowNegative={false} ref={ref} />
));
const CampaignEquity = (props) => {
  //过于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  //人群类型
  const { cardType } = props;
  const { register } = useFormContext();
  const { control, setCouponList, couponList, status, activityGroupDetail } =
    props;

  //关于优惠券
  const theme = useTheme();
  //打开优惠券模板
  const [open, setOpen] = useState();
  const handleCancel = () => {
    setOpen(false);
  };
  const onClose = () => {
    setOpen(false);
  };

  const handleSubmitSuccess = (selectList) => {
    setOpen(false);
    setCouponList(selectList);
  };
  //
  const handleSetting = () => {
    setOpen(true);
  };
  //删除优惠券
  const handleDeleteCouponItem = (id) => {
    if (status !== 'detail') {
      let selectedCouponList = [...couponList];
      let Index = -1;
      selectedCouponList.map((i, index) => {
        if (i.id === id) {
          Index = index;
        }
      });
      Index >= 0 && selectedCouponList.splice(Index, 1);
      setCouponList(selectedCouponList);
    }
  };

  const levelData = [
    {
      id: 5,
      name: '优惠券ID',
    },
    {
      id: 0,
      name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl01' }),
    },
    {
      id: 1,
      name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl02' }),
    },
    {
      id: 2,
      name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl03' }),
    },
    {
      id: 3,
      name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl04' }),
    },
    {
      id: 4,
      name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl05' }),
    },
  ];

  return (
    <CampaignEquityStyled theme={theme}>
      <Box className="title">
        {cardType === 'specify'
          ? '活动权益'
          : formatMessage({ id: 'marketing.people.regnotcon.n04.lbl01' })}
      </Box>
      <Box className="coupon" mt={3}>
        {formatMessage({ id: 'marketing.people.regnotcon.n04.lbl02' })}
      </Box>
      <Box mt={2}>
        <Controller
          register
          as={(pr) => (
            <FormControlLabel
              className="checkbox-radio-disabled-color"
              variant="standard"
              disabled={status === 'detail'}
              checked={pr.value ?? activityGroupDetail?.isCouponDelivery}
              control={<Checkbox color="primary" />}
              label={formatMessage({
                id: 'marketing.people.regnotcon.n04.btn03',
              })}
              onChange={(e) => {
                return pr.onChange(e.target.checked);
              }}
            />
          )}
          control={control}
          name="isCouponDelivery"
        />
      </Box>
      <Box className="desc" mt={2}>
        {formatMessage({ id: 'marketing.people.regnotcon.n04.lbl04' })}
      </Box>
      {status !== 'detail' && (
        <Box className="link" onClick={handleSetting}>
          {formatMessage({ id: 'marketing.people.regnotcon.n04.btn03' })}
        </Box>
      )}

      <Box mt={2}>
        <Box className="table">
          <Box className="table-title">
            {levelData &&
              levelData.map((title, i) => {
                return (
                  <div key={i} className={i === 1 && 'subTitle'}>
                    {title.name}
                  </div>
                );
              })}
          </Box>
          <Box className="table-content">
            {couponList &&
              couponList.length > 0 &&
              couponList?.map((item, index) => {
                return (
                  <Box className="table-row" key={index}>
                    <div className="coupon-id">{item?.id}</div>
                    <div className="coupon-title">{item?.title}</div>
                    <div className="subTitle">{item?.subTitle}</div>
                    <div className="surplus">{item?.surplus}</div>
                    <div className="action">
                      <SvgIconML
                        name={'coupon'}
                        size={18}
                        className="coupon"
                      ></SvgIconML>
                      <span className="coupon-num">
                        <Controller
                          register={register}
                          name={`givenNum${index}`}
                          variant="standard"
                          type="number"
                          disabled={status === 'detail'}
                          K
                          // required
                          placeholder={''}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">张</InputAdornment>
                            ),
                          }}
                          render={(rp) => (
                            <TextField
                              name={`givenNum${index}`}
                              variant="standard"
                              register={register}
                              disabled={status === 'detail'}
                              // type="number"
                              value={item.givenNum}
                              // required
                              placeholder={''}
                              InputProps={{
                                inputComponent: NumberFormatCustom,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    张
                                  </InputAdornment>
                                ),
                              }}
                              onChange={(e) => {
                                const currentCouponList = [];
                                couponList.map((i) => {
                                  if (i.id === item.id) {
                                    i.givenNum = e.target.value;
                                    currentCouponList.push(i);
                                  } else {
                                    currentCouponList.push(i);
                                  }
                                  return currentCouponList;
                                });
                                setCouponList(currentCouponList);
                                return rp.onChange(e.target.value);
                              }}
                            />
                          )}
                          control={control}
                          id="basic"
                          className="basic-name"
                          label={''}
                        />
                      </span>
                    </div>
                    <div className="delete">
                      <ButtonTip title="删除">
                        <IconButton
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          color="inherit"
                          disabled={status === 'detail'}
                          onClick={() => handleDeleteCouponItem(item.id)}
                        >
                          <DeleteForeverOutlinedIcon
                            style={{
                              fontSize: '20px',
                              color:
                                status === 'detail'
                                  ? theme.palette.secondary.disabled
                                  : theme.palette.primary.main,
                            }}
                          />
                        </IconButton>
                      </ButtonTip>
                    </div>
                  </Box>
                );
              })}
          </Box>
        </Box>
      </Box>

      <ModalML
        open={open}
        setOpen={setOpen}
        onCancel={handleCancel}
        title={formatMessage({ id: 'marketing.people.regnotcon.d01.lbl02' })}
        onConfirm={handleSubmitSuccess}
        onClose={onClose}
      >
        <CouponModal
          open={open}
          control={control}
          setOpen={setOpen}
          onConfirm={handleSubmitSuccess}
          couponList={couponList}
        ></CouponModal>
      </ModalML>
    </CampaignEquityStyled>
  );
};
export default CampaignEquity;
